import type {Translator} from "./i18n";
import {diagnosticCatalog} from "./diagnosticCatalog";
import {mailErrorText} from "./mailErrors";

export type Diagnostic = {code:string;params?:Record<string,string|number|boolean|null>};
export type DiagnosticRecord = {diagnostic?:Diagnostic;message?:string};
export function formatDiagnostic(value:Diagnostic|undefined,t:Translator):string{
 if(!value?.code)return "";
 const smtpCode=value.params?.smtp_code;
 const mail=mailErrorText(value.code,t,typeof smtpCode==="number"?smtpCode:0);
 if(mail)return mail;
 const copy=diagnosticCatalog[value.code];
 if(!copy)return t(`诊断代码：${value.code}`,`Diagnostic code: ${value.code}`);
 return t(copy[0],copy[1]).replace(/\{([a-zA-Z0-9_]+)\}/g,(placeholder,key)=>{
  const parameter=value.params?.[key];return parameter==null?placeholder:String(parameter);
 });
}
export function errorDiagnostic(error:unknown):Diagnostic|undefined{
 if(error&&typeof error==="object"&&"diagnostic" in error)return (error as {diagnostic?:Diagnostic}).diagnostic;
 return undefined;
}
export function diagnosticErrorText(error:unknown,t:Translator):string{
 const value=errorDiagnostic(error);if(value?.code)return formatDiagnostic(value,t);
 if(typeof error==="string")return error;
 if(error instanceof Error)return error.message;
 return t("请求失败，请稍后重试。","The request failed. Try again later.");
}
